/**
 * あおぞらワールドの静的データ (自動生成 — 手で編集しない)。
 *
 * 生成: `pnpm gen:world` (scripts/gen-world-data.ts が computeWorldOverlay() を実行)。
 * WORLD_SEED=20260717 の全域スキャン結果 (街 53 / 橋 10 スパン)。
 * world.test.ts が「再生成 = 本データ」を検証する (アルゴリズム変更の検知)。
 */
import type { WorldOverlayData } from './world.js';

export const WORLD_DATA: WorldOverlayData = {
  "towns": [
    {
      "x": 64,
      "y": 64,
      "region": 0,
      "name": "そらみの街"
    },
    {
      "x": 192,
      "y": 64,
      "region": 1,
      "name": "かぜまちの宿場"
    },
    {
      "x": 460,
      "y": 51,
      "region": 3,
      "name": "ひばりの丘"
    },
    {
      "x": 579,
      "y": 86,
      "region": 4,
      "name": "しらかばの里"
    },
    {
      "x": 668,
      "y": 28,
      "region": 5,
      "name": "こもれびの村"
    },
    {
      "x": 835,
      "y": 66,
      "region": 6,
      "name": "つばめの街"
    },
    {
      "x": 960,
      "y": 64,
      "region": 7,
      "name": "ゆうなぎの浜"
    },
    {
      "x": 64,
      "y": 192,
      "region": 8,
      "name": "みなもの街"
    },
    {
      "x": 191,
      "y": 191,
      "region": 9,
      "name": "あおばの宿場"
    },
    {
      "x": 448,
      "y": 192,
      "region": 11,
      "name": "ほしぞらの丘"
    },
    {
      "x": 576,
      "y": 192,
      "region": 12,
      "name": "たきおとの里"
    },
    {
      "x": 667,
      "y": 228,
      "region": 13,
      "name": "いわかげの宿"
    },
    {
      "x": 851,
      "y": 174,
      "region": 14,
      "name": "なぎさの村"
    },
    {
      "x": 960,
      "y": 192,
      "region": 15,
      "name": "うみねこの湊"
    },
    {
      "x": 64,
      "y": 320,
      "region": 16,
      "name": "このはの街"
    },
    {
      "x": 211,
      "y": 340,
      "region": 17,
      "name": "ふたばの村"
    },
    {
      "x": 295,
      "y": 344,
      "region": 18,
      "name": "せせらぎの里"
    },
    {
      "x": 448,
      "y": 320,
      "region": 19,
      "name": "やまびこの宿場"
    },
    {
      "x": 573,
      "y": 317,
      "region": 20,
      "name": "くもまの街"
    },
    {
      "x": 704,
      "y": 320,
      "region": 21,
      "name": "かげろうの村"
    },
    {
      "x": 832,
      "y": 320,
      "region": 22,
      "name": "しおさいの湊"
    },
    {
      "x": 965,
      "y": 314,
      "region": 23,
      "name": "いそかぜの浜"
    },
    {
      "x": 192,
      "y": 448,
      "region": 25,
      "name": "とんぼの原"
    },
    {
      "x": 320,
      "y": 448,
      "region": 26,
      "name": "ほむらの街"
    },
    {
      "x": 562,
      "y": 426,
      "region": 28,
      "name": "おおたきの宿"
    },
    {
      "x": 721,
      "y": 431,
      "region": 29,
      "name": "けものみちの砦"
    },
    {
      "x": 813,
      "y": 429,
      "region": 30,
      "name": "あらいその湊"
    },
    {
      "x": 196,
      "y": 575,
      "region": 33,
      "name": "ななくさの村"
    },
    {
      "x": 316,
      "y": 572,
      "region": 34,
      "name": "こだまの杜"
    },
    {
      "x": 576,
      "y": 576,
      "region": 36,
      "name": "いただきの関"
    },
    {
      "x": 715,
      "y": 581,
      "region": 37,
      "name": "たかねの砦"
    },
    {
      "x": 818,
      "y": 588,
      "region": 38,
      "name": "しんりんの宿"
    },
    {
      "x": 64,
      "y": 704,
      "region": 40,
      "name": "はるかぜの村"
    },
    {
      "x": 197,
      "y": 699,
      "region": 41,
      "name": "あぜみちの里"
    },
    {
      "x": 347,
      "y": 677,
      "region": 42,
      "name": "どんぐりの杜"
    },
    {
      "x": 448,
      "y": 704,
      "region": 43,
      "name": "かすみの街"
    },
    {
      "x": 576,
      "y": 704,
      "region": 44,
      "name": "いしだたみの宿場"
    },
    {
      "x": 710,
      "y": 687,
      "region": 45,
      "name": "おにびの関"
    },
    {
      "x": 849,
      "y": 724,
      "region": 46,
      "name": "ふかもりの砦"
    },
    {
      "x": 958,
      "y": 705,
      "region": 47,
      "name": "しらなみの湊"
    },
    {
      "x": 64,
      "y": 832,
      "region": 48,
      "name": "ひなたの村"
    },
    {
      "x": 192,
      "y": 832,
      "region": 49,
      "name": "むぎばたけの里"
    },
    {
      "x": 320,
      "y": 832,
      "region": 50,
      "name": "きつつきの杜"
    },
    {
      "x": 439,
      "y": 823,
      "region": 51,
      "name": "よあけの街"
    },
    {
      "x": 599,
      "y": 809,
      "region": 52,
      "name": "さかみちの宿"
    },
    {
      "x": 707,
      "y": 835,
      "region": 53,
      "name": "やまねこの砦"
    },
    {
      "x": 832,
      "y": 832,
      "region": 54,
      "name": "くらやみの関"
    },
    {
      "x": 963,
      "y": 829,
      "region": 55,
      "name": "はてしの灯台"
    },
    {
      "x": 71,
      "y": 966,
      "region": 56,
      "name": "あかつきの村"
    },
    {
      "x": 174,
      "y": 942,
      "region": 57,
      "name": "いなほの里"
    },
    {
      "x": 710,
      "y": 933,
      "region": 61,
      "name": "おおわしの砦"
    },
    {
      "x": 808,
      "y": 936,
      "region": 62,
      "name": "まぼろしの関"
    },
    {
      "x": 960,
      "y": 960,
      "region": 63,
      "name": "さいはての湊"
    }
  ],
  "bridgeTiles": [
    {
      "x": 901,
      "y": 154
    },
    {
      "x": 901,
      "y": 155
    },
    {
      "x": 901,
      "y": 156
    },
    {
      "x": 901,
      "y": 157
    },
    {
      "x": 901,
      "y": 158
    },
    {
      "x": 83,
      "y": 235
    },
    {
      "x": 84,
      "y": 235
    },
    {
      "x": 85,
      "y": 235
    },
    {
      "x": 86,
      "y": 235
    },
    {
      "x": 87,
      "y": 235
    },
    {
      "x": 84,
      "y": 258
    },
    {
      "x": 85,
      "y": 258
    },
    {
      "x": 86,
      "y": 258
    },
    {
      "x": 87,
      "y": 258
    },
    {
      "x": 88,
      "y": 258
    },
    {
      "x": 70,
      "y": 341
    },
    {
      "x": 70,
      "y": 342
    },
    {
      "x": 70,
      "y": 343
    },
    {
      "x": 70,
      "y": 344
    },
    {
      "x": 70,
      "y": 345
    },
    {
      "x": 631,
      "y": 551
    },
    {
      "x": 632,
      "y": 551
    },
    {
      "x": 633,
      "y": 551
    },
    {
      "x": 634,
      "y": 551
    },
    {
      "x": 635,
      "y": 551
    },
    {
      "x": 632,
      "y": 584
    },
    {
      "x": 633,
      "y": 584
    },
    {
      "x": 634,
      "y": 584
    },
    {
      "x": 635,
      "y": 584
    },
    {
      "x": 636,
      "y": 584
    },
    {
      "x": 390,
      "y": 658
    },
    {
      "x": 391,
      "y": 658
    },
    {
      "x": 392,
      "y": 658
    },
    {
      "x": 393,
      "y": 658
    },
    {
      "x": 394,
      "y": 658
    },
    {
      "x": 392,
      "y": 680
    },
    {
      "x": 393,
      "y": 680
    },
    {
      "x": 394,
      "y": 680
    },
    {
      "x": 395,
      "y": 680
    },
    {
      "x": 396,
      "y": 680
    },
    {
      "x": 394,
      "y": 702
    },
    {
      "x": 395,
      "y": 702
    },
    {
      "x": 396,
      "y": 702
    },
    {
      "x": 397,
      "y": 702
    },
    {
      "x": 398,
      "y": 702
    },
    {
      "x": 1017,
      "y": 736
    },
    {
      "x": 1017,
      "y": 737
    },
    {
      "x": 1017,
      "y": 738
    },
    {
      "x": 1017,
      "y": 739
    },
    {
      "x": 1017,
      "y": 740
    }
  ],
  "bridgeSpans": 10,
  "spawn": {
    "x": 211,
    "y": 340,
    "region": 17,
    "name": "ふたばの村"
  }
};
